import styled from 'styled-components';

export const PageWrapper = styled.div`
	.dropdown-menu {
		right: 0;
		left: unset !important; // overrides inline styles!
	}
`;
